(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login-react/assets/react/shared-components/iam-iframe-message-handler.js') >= 0) return;  svs.modules.push('/modules/player-login-react/assets/react/shared-components/iam-iframe-message-handler.js');

'use strict';

var _svs, _svs2;
const POST_MESSAGE_SOURCE = 'svs-iam-parent';
const TARGET_ORIGIN = (_svs = svs) === null || _svs === void 0 || (_svs = _svs.playerLoginReact) === null || _svs === void 0 || (_svs = _svs.data) === null || _svs === void 0 || (_svs = _svs.origins) === null || _svs === void 0 ? void 0 : _svs.target;
const TRUSTED_ORIGIN = (_svs2 = svs) === null || _svs2 === void 0 || (_svs2 = _svs2.playerLoginReact) === null || _svs2 === void 0 || (_svs2 = _svs2.data) === null || _svs2 === void 0 || (_svs2 = _svs2.origins) === null || _svs2 === void 0 ? void 0 : _svs2.trusted;
if (svs.core.detect.feature('ft-iam-iframe')) {
  const POST_MESSAGE_TYPES = {
    HEIGHT: 'height',
    SHOW_DIALOG: 'showDialog',
    PARENT_REDIRECT: 'parentRedirect',
    SHOW_DIALOG_RESOLVE: 'show-dialog-resolve',
    GET_BRANDING: 'get-branding'
  };
  const {
    showDialog
  } = svs.playerLoginReact.sharedComponents.Dialogs;
  window.addEventListener('message', async event => {
    var _event$data;
    if (event.origin !== TRUSTED_ORIGIN) {
      return; 
    }
    const iframe = document.getElementById('iamlogin-iframe');
    if ((event === null || event === void 0 || (_event$data = event.data) === null || _event$data === void 0 ? void 0 : _event$data.source) === 'svs-iam-iframe') {
      var _event$data2, _event$data5, _event$data10, _event$data13;
      if ((event === null || event === void 0 || (_event$data2 = event.data) === null || _event$data2 === void 0 ? void 0 : _event$data2.messageType) === POST_MESSAGE_TYPES.HEIGHT) {
        var _event$data3, _event$data4;
        iframe.style.height = (_event$data3 = event.data) !== null && _event$data3 !== void 0 && _event$data3.value ? "".concat((_event$data4 = event.data) === null || _event$data4 === void 0 ? void 0 : _event$data4.value, "px") : 'auto';
      } else if ((event === null || event === void 0 || (_event$data5 = event.data) === null || _event$data5 === void 0 ? void 0 : _event$data5.messageType) === POST_MESSAGE_TYPES.SHOW_DIALOG) {
        var _event$data6, _event$data7, _event$data8;
        await showDialog((_event$data6 = event.data) === null || _event$data6 === void 0 || (_event$data6 = _event$data6.value) === null || _event$data6 === void 0 ? void 0 : _event$data6.title, (_event$data7 = event.data) === null || _event$data7 === void 0 || (_event$data7 = _event$data7.value) === null || _event$data7 === void 0 ? void 0 : _event$data7.errorMessage);
        iframe.contentWindow.postMessage({
          source: POST_MESSAGE_SOURCE,
          messageType: POST_MESSAGE_TYPES.SHOW_DIALOG_RESOLVE
        }, TARGET_ORIGIN);
        if ((_event$data8 = event.data) !== null && _event$data8 !== void 0 && (_event$data8 = _event$data8.value) !== null && _event$data8 !== void 0 && _event$data8.redirectUrl) {
          var _event$data9;
          window.location.href = (_event$data9 = event.data) === null || _event$data9 === void 0 || (_event$data9 = _event$data9.value) === null || _event$data9 === void 0 ? void 0 : _event$data9.redirectUrl;
        }
      } else if ((event === null || event === void 0 || (_event$data10 = event.data) === null || _event$data10 === void 0 ? void 0 : _event$data10.messageType) === POST_MESSAGE_TYPES.PARENT_REDIRECT) {
        var _event$data11, _event$data12;
        window.location.href = (_event$data11 = event.data) !== null && _event$data11 !== void 0 && _event$data11.value ? (_event$data12 = event.data) === null || _event$data12 === void 0 ? void 0 : _event$data12.value : svs.core.urlMapping.get('startPage');
      } else if ((event === null || event === void 0 || (_event$data13 = event.data) === null || _event$data13 === void 0 ? void 0 : _event$data13.messageType) === POST_MESSAGE_TYPES.GET_BRANDING) {
        var _extraData$branding, _extraData$branding$t;
        const extraData = await svs.accountservices.onboardingHandler.getExtraData();
        const theme = svs.accountservices.onboardingHandler.getTheme((extraData === null || extraData === void 0 || (_extraData$branding = extraData.branding) === null || _extraData$branding === void 0 || (_extraData$branding$t = _extraData$branding.toLowerCase) === null || _extraData$branding$t === void 0 ? void 0 : _extraData$branding$t.call(_extraData$branding)) || '');
        iframe.contentWindow.postMessage({
          source: POST_MESSAGE_SOURCE,
          messageType: POST_MESSAGE_TYPES.GET_BRANDING,
          value: {
            product: (theme === null || theme === void 0 ? void 0 : theme.branding) || 'tur-100'
          }
        }, TARGET_ORIGIN);
      }
    }
  });
}

 })(window);